import { createSlice } from "@reduxjs/toolkit";
import { getMe, userLogin, signUp, patchMe } from "./authActions";
import LocalStorageService from "../../common/services/LocalStorageService";

// initialize userToken from local storage
const userToken = LocalStorageService?.get("authorizationData")
  ? LocalStorageService?.get("authorizationData")?.access
  : null;

const groups = LocalStorageService?.get("authorizationData")
  ? LocalStorageService?.get("authorizationData")?.groups
  : [];

const initialState = {
  loading: false,
  userToken: userToken ? userToken : "",
  error: null,
  success: false,
  isAuthenticated: userToken ? true : false,
  groups,
  info: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuthError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
    logOut: (state) => {
      state.success = false;
      state.error = null;
      state.userToken = null;
      state.info = {};
      state.loading = false;
      state.isAuthenticated = false;
      state.groups = [];
      LocalStorageService.remove("authorizationData");
      LocalStorageService.remove("has_cashier_entered_desk_number");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.loading = true;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.info = action?.payload?.user;
        state.groups = action?.payload?.user?.groups;
        state.userToken = action?.payload?.access;
        state.isAuthenticated = true;
        state.loading = false;
        state.success = true;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.error = action.payload;
        state.isAuthenticated = false;
        state.loading = false;
      })
      .addCase(getMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMe.fulfilled, (state, action) => {
        state.loading = false;
        state.info = action?.payload;
      })
      .addCase(getMe.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(patchMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(patchMe.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(patchMe.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.error = action?.payload;
        state.isAuthenticated = false;
        state.loading = false;
      });
  },
});
export const { resetAuthError, logOut } = authSlice.actions;
export default authSlice.reducer;
